import { Box, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

import theme from "@/theme";

const useStyles = makeStyles(() => ({
  wrapper: {
    display: "flex",
    justifyContent: "center",
  },
  heading: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 1.5,
    textAlign: "center",
    color: theme.palette.semantic["text/primary"],
    [theme.breakpoints.up("md")]: { fontSize: 24 },
  },
  accent: { color: theme.palette.semantic["action/primary"], whiteSpace: "nowrap" },
}));

export const DiagnosisCompatibilityAgentsHeading: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.wrapper}>
      <Typography component="h1" className={classes.heading}>
        試しに一人、<span className={classes.accent}>認定プランナー</span>と<br />マッチしてみましょう！
      </Typography>
    </Box>
  );
};
